module.exports = __webpack_public_path__ + "static/media/wall1-long.08162704.jpg";